module.exports = __webpack_public_path__ + "static/media/Icons_user_info.6ef467ce.svg";